import Marquee from "react-fast-marquee";
import { CLIENTS } from "../../lib/site";

const Chip = ({ c }) => (
  <span className="mx-3 inline-flex h-16 items-center justify-center gap-2 whitespace-nowrap rounded-full border border-line bg-white/70 px-7 transition-colors duration-300 hover:border-forest">
    {c.logo ? (
      <img src={c.logo} alt={c.name} className="h-10 w-auto object-contain" loading="lazy" />
    ) : (
      <span className="font-heading text-lg font-bold uppercase tracking-wide text-moss transition-colors duration-300 group-hover:text-forest">{c.name}</span>
    )}
  </span>
);

export default function TrustedBy() {
  const half = Math.ceil(CLIENTS.length / 2);
  const row1 = CLIENTS.slice(0, half);
  const row2 = CLIENTS.slice(half);
  return (
    <section data-testid="trusted-by" className="border-y border-line bg-cream py-16 md:py-20">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <p className="text-center text-xs uppercase tracking-[0.3em] text-moss">Trusted by leading organizations</p>
      </div>
      <div className="mt-10 space-y-4">
        <Marquee speed={35} gradient={false} autoFill>
          {row1.map((c) => <Chip key={c.name} c={c} />)}
        </Marquee>
        <Marquee speed={35} direction="right" gradient={false} autoFill>
          {row2.map((c) => <Chip key={c.name} c={c} />)}
        </Marquee>
      </div>
    </section>
  );
}
